import React from 'react';
const NotFound = () => {
  return /*#__PURE__*/React.createElement("p", null, "Page not found.");
};
export default NotFound;